import { createApp } from "vue"
import { createRouter, createWebHistory } from 'vue-router'

import BannerComponent from "./components/BannerComponent.vue";
import NavigationComponent from "./components/NavigationComponent.vue";
import SubBanner from "./components/SubBanner.vue";
import FeaturedPartners from "./components/FeaturedPartners.vue";
import LogosComponent from "./components/LogosComponent.vue";
import FeaturedGalleries from "./components/FeaturedGalleries.vue";
import CollectionSearch from "./components/CollectionSearch.vue";
import CollectionResults from "./components/CollectionResults.vue";
import DatabaseItem from "./components/DatabaseItem.vue";
import SearchResults from "./components/SearchResults.vue";
import SearchHowTo from "./components/SearchHowTo.vue";
import PartnersPage from "./components/PartnersPage.vue";
import PartnerProfile from "./components/PartnerProfile.vue";
import PartnerObjects from "./components/PartnerObjects.vue";
import TimelinePage from "./components/TimelinePage.vue";
import TimelineResults from "./components/TimelineResults.vue";
import TimelineGallery from "./components/TimelineGallery.vue";
import AboutPage from "./components/AboutPage.vue";
import CreditsPage from "./components/CreditsPage.vue";
import ErrorPage from "./components/ErrorPage.vue";

// Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "home",
        components: {
            "banner": BannerComponent,
            "navigation": NavigationComponent,
            "featured-partners": FeaturedPartners,
            "logos": LogosComponent,
            "featured-galleries": FeaturedGalleries
        }
    },
    {
        path: "/collection",
        name: "collection",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: CollectionSearch
        }
    },
    {
        path: "/collection-results",
        name: "collection-results",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: CollectionResults
        }
    },
    {
        path: "/database-item/:pathMatch(.*)*/:language",
        name: "database-item",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: DatabaseItem
        }
    },
    {
        path: "/search",
        name: "search-results",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: SearchResults
        }
    },
    {
        path: "/how-to-search",
        name: "search-how-to",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: SearchHowTo
        }
    },
    {
        path: "/partners",
        name: "partners",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: PartnersPage
        }
    },
    {
        path: "/partner/:database/:country/:id/:language",
        name: "partner",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: PartnerProfile
        }
    },
    {
        path: "/partner-objects/:database/:country/:id/:page",
        name: "partner-objects",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: PartnerObjects
        }
    },
    {
        path: "/timeline",
        name: "timeline",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: TimelinePage
        }
    },
    {
        path: "/timeline-results",
        name: "timeline-results",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: TimelineResults
        }
    },
    {
        path: "/timeline-gallery/:country/:start/:end/:page",
        name: "timeline-gallery",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: TimelineGallery
        }
    },
    {
        path: "/about",
        name: "about",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: AboutPage
        }
    },
    {
        path: "/credits",
        name: "credits",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: CreditsPage
        }
    },
    {
        path: "/error",
        name: "error",
        components: {
            "navigation": NavigationComponent,
            "sub-banner": SubBanner,
            default: ErrorPage
        }
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/error"
    }
];

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_ROUTE),
    routes,
    scrollBehavior(to, from, savedPosition) {
      console.log(to);
      if (to.hash) {
        setTimeout(() => {
          const element = document.getElementById(to.hash.replace(/#/, ""))
          if (element && element.scrollIntoView) {
            element.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
        }, 1000);
        return { el: to.hash, behavior: 'smooth', };
      } else if (!to.path.includes("chronology") && savedPosition) {
        return savedPosition;
      } else {
        return window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  });
  
  export default router;